import { createReducer } from 'redux-create-reducer';
import {
  updateDataAction,
  receiveFormAction,
  requestFormAction,
} from '../actions/form';
import dotProp from 'dot-prop-immutable';
import moment from 'moment';
import { DATE_FORMAT } from 'common/components/PreplanificationSelection';

const generalInformationsInitialState = {
  installDate: '',
  nextRenewal: '',
  initialDuration: null,
  automaticRenewal: true,
};

const invoicingInformationsInitialState = {
  invoicing: true,
  invoiceLines: [],
  lastInvoiceAmount: undefined,
  lastInvoiceIssueDate: undefined,
  indexationPercentage: 0,
  balanceInvoiceCreateAction: true,
  balanceInvoiceDate: '',
  balanceInvoicePaymentDate: moment()
    .add(30, 'days')
    .format(DATE_FORMAT),
  balanceInvoicePaymentCondition: '30_DAYS',
  balanceInvoicePaymentFrequency: 1,
};

const initialState = {
  generalInformations: generalInformationsInitialState,
  invoicingInformations: invoicingInformationsInitialState,
  isFetching: false,
  errors: [],
};

const ERRORS = 'errors';

export const formReducer = createReducer(initialState, {
  [updateDataAction]: (state, action) => {
    const { propName, propValue } = action.payload;
    return dotProp.set(state, propName, propValue);
  },
  [requestFormAction](state) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [receiveFormAction](state, action) {
    return {
      ...state,
      ...action.payload,
      errors: [],
      isFetching: false,
    };
  },
  [ERRORS](state, action) {
    return {
      ...state,
      errors: action.payload,
    };
  },
});

export default formReducer;

export const getErrors = state => state.form.errors;
export const getInstallDate = state =>
  state.form.generalInformations.installDate;
export const getInitialDuration = state =>
  state.form.generalInformations.initialDuration;
export const getAutonamticRenewal = state =>
  state.form.generalInformations.automaticRenewal;
export const getNextRenewal = state =>
  state.form.generalInformations.nextRenewal;

export const getInvoicing = state => state.form.invoicingInformations.invoicing;
export const getInvoiceLines = state =>
  state.form.invoicingInformations.invoiceLines;
export const getLastInvoiceAmount = state =>
  state.form.invoicingInformations.lastInvoiceAmount;
export const getLastInvoiceIssueDate = state =>
  state.form.invoicingInformations.lastInvoiceIssueDate;
export const getIndexationPercentage = state =>
  state.form.invoicingInformations.indexationPercentage;
export const getBalanceInvoiceCreateAction = state =>
  state.form.invoicingInformations.balanceInvoiceCreateAction;
export const getBalanceInvoiceDate = state =>
  state.form.invoicingInformations.balanceInvoiceDate;
export const getBalanceInvoicePaymentDate = state =>
  state.form.invoicingInformations.balanceInvoicePaymentDate;
export const getBalanceInvoicePaymentCondition = state =>
  state.form.invoicingInformations.balanceInvoicePaymentCondition;
export const getBalanceInvoicePaymentFrequency = state =>
  state.form.invoicingInformations.balanceInvoicePaymentFrequency;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/renew/reducers/form.js